import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    if (isRefreshTokenRequest(req)) {
      return next.handle(req);
    }

    return this.authService.userInfo$.pipe(
      first(),
      switchMap((userInfo) => {
        if (userInfo.access_token) {
          // Clone the request and set the new header in one step.
          const authReq = req.clone({
            setHeaders: {
              Authorization: `${userInfo.token_type} ${userInfo.access_token}`,
            },
          });

          // send cloned request with header to the next handler.
          return next.handle(authReq);
        } else {
          return next.handle(req);
        }
      }),
    );
  }
}

function isRefreshTokenRequest(req: HttpRequest<any>) {
  return typeof req.body === 'string' && req.url.includes('grant_type=refresh_token');
}
